import { render, staticRenderFns } from "./RightFooter.vue?vue&type=template&id=aaaef70c&"
import script from "./RightFooter.vue?vue&type=script&lang=js&"
export * from "./RightFooter.vue?vue&type=script&lang=js&"
import style0 from "./RightFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports